export const getIcRetry = state => state.icRetry;
export const getIcVerifyRetry = state => state.icVerifyRetry;



// WEBPACK FOOTER //
// ./src/redux/counter/selectors.js